export default __webpack_public_path__ + "static/seaforth.c828bc278cb2ae8889dc22e6810e47c8.png";